import React from 'react';
import { useSelector } from 'react-redux';

interface ISidebarRightProps {
  children: JSX.Element;
  style: React.CSSProperties;
}

const SidebarRight = (props: ISidebarRightProps) => {
  const { children, style } = props;
  const { sidebarRight } = useSelector((state: any) => state.layoutState);

  return (
    <div
      id="box-sidebar-right"
      className={sidebarRight ? 'open-sidebar' : ''}
      style={style}
      data-cy="SidebarRight"
    >
      {children}
    </div>
  );
};

export default SidebarRight;
